var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtSwim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.1,
    cy: 61.6,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.3,
    cy: 61.6,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,97.8c-1.9-1.3-4-2.8-8-2.8c-4,0-6.1,1.5-8,2.8c-1.1,0.8-2.2,1.5-3.6,2c0.1,0,0.2-0.1,0.3-0.1V38.6 c0-1.4-0.6-2.7-1.5-3.6c-0.9-0.9-2.2-1.5-3.6-1.5c-1.4,0-2.7,0.6-3.6,1.5c-0.9,0.9-1.5,2.2-1.5,3.6v35.9H73.3v10.3h21.9v11.6 c-0.9,0.5-1.6,1-2.3,1.5c-1.7,1.2-3.2,2.3-6.4,2.3s-4.7-1.1-6.4-2.3c-1.9-1.3-4-2.8-8-2.8c-1,0-1.8,0.1-2.6,0.2V38.5 c0-1.4-0.6-2.7-1.5-3.6c-0.9-0.9-2.2-1.5-3.6-1.5s-2.7,0.6-3.6,1.5s-1.5,2.2-1.5,3.6v35.9H12.9c-2.8,0-5.1,2.3-5.1,5.1 c0,2.8,2.3,5.1,5.1,5.1h33.4v10.6c-0.9-0.2-1.9-0.3-3.1-0.3c-4,0-6.1,1.5-8,2.8c-1.7,1.2-3.2,2.3-6.4,2.3s-4.7-1.1-6.4-2.3 c-1.9-1.3-4-2.8-8-2.8s-6.1,1.5-8,2.8c-1.7,1.3-3.2,2.3-6.4,2.3v2.7c4,0,6.1-1.5,8-2.8c1.7-1.3,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3 c1.9,1.3,4,2.8,8,2.8s6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8s6.1-1.5,8-2.8 c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8c4,0,6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3 c1.9,1.3,4,2.8,8,2.8c4,0,6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3c3.2,0,4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8v-2.7 C140.8,100.1,139.3,99.1,137.6,97.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtSwim);
export default __webpack_public_path__ + "static/media/artSwim.c00710eb355466f8673733c0f3a51f30.svg";
export { ForwardRef as ReactComponent };